module.exports = __webpack_public_path__ + "img/depmap_svg_V39.9f476d0e.svg";